import ShorcutsList from './ShorcutsList';

export default ShorcutsList;
